import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import CheckboxField from '../../../../reusable-components/CheckboxField';
import PageContent from '../../../../reusable-components/PageContent';
import PageHeader from '../../../../reusable-components/PageHeader';
import { required, email, compare_email, checked } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import ModalComponent from '../../../../reusable-components/Modal';
import Spinner from '../../../../reusable-components/Spinner'; 
import { Row, Col, Button, } from 'react-bootstrap';
import PropTypes from 'prop-types';

class GetUserDetailsForm extends Component {
  constructor(props){
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values){
    const { saveUserDetails, history } = this.props;
    saveUserDetails(values);
    history.push('/extend/UploadDocuments');
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, initialValues } = this.props;

    let buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <React.Fragment>
        <PageHeader title="Persoonlijke informatie" />
        <PageContent 
          title=""
          goBack={() => {
            this.props.history.goBack()
          }}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={true}
          hasBackBtn={true}
          formClassNames=""
          buttonState={isloading}
          submitting={submitting}
          btnDisabled={submitting}
          handleSubmit={handleSubmit(this.onSubmit)}>
          <div className="form-container">
            <div className="form-row">
              <div className="form-group col-sm-5 col-md-5">
                <Field
                  required
                  type="text"
                  name="name"
                  label="Achternaam"
                  component={InputField}
                  validate={required}
                />
              </div>
              <div className="form-group col-sm-2 col-md-2 offset-md-1">
                <Field
                  type="text"
                  name="prefix"
                  label="Tussenvoegsel"
                  component={InputField}
                />
              </div>
              <div className="form-group col-sm-6 col-md-3 offset-md-1">
                <Field
                  required
                  type="text"
                  name="first_name"
                  label="Voorletters"
                  component={InputField}
                  validate={required}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-sm-6 col-md-6">
                <Field
                  required
                  type="text"
                  name="address"
                  label="Adres"
                  component={InputField}
                  validate={required}
                />
              </div>
              <div className="form-group col-sm-6 col-md-2 offset-md-1">
                <Field
                  required
                  type="text"
                  name="number"
                  label="Huisnummer"
                  component={InputField}
                  validate={required}
                />
              </div>
              <div className="form-group col-sm-6 col-md-2 offset-md-1">
                <Field
                  required
                  type="text"
                  name="postal_code"
                  label="Postcode"
                  component={InputField}
                  validate={required}
                />
              </div>
            </div>
            <div className="form-row d-flex justify-content-between">
              <div className="form-group col-sm-6 col-md-3">
                <Field
                  required
                  type="text"
                  name="city"
                  label="Plaats"
                  component={InputField}
                  validate={required}
                />
              </div>
              <div className="form-group col-sm-6 col-md-3">
                <Field
                  required
                  type="text"
                  name="email"
                  label="Email"
                  component={InputField}
                  validate={[required, email]}
                />
              </div>
              <div className="form-group col-sm-6 col-md-3">
                <Field
                  required
                  type="text"
                  name="confirm_email"
                  label="Bevestig Email"
                  component={InputField}
                  validate={[required, email, compare_email]}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-sm-6 col-md-6">
                <Field
                  required
                  type="text"
                  name="phone"
                  label="Telefoon nummer"
                  component={InputField}
                  validate={required}
                />
              </div>
              <div className="form-group col-sm-6 col-md-6">
                <Field
                  required
                  type="text"
                  name="mobile_phone"
                  label="Mobiel nummer"
                  component={InputField}
                  validate={required}
                />
              </div>
            </div>
            <div className="form-row checkbox-margin-top">
              <div className="form-group col-md-12">
                <Field 
                  name="agreement" 
                  component={CheckboxField} 
                  type="checkbox"
                  validate={checked} 
                  required
                />
              </div>
            </div>
            {/*<Row>
              <Col md={12}>
                <div className="footer-btn-container">
                  <Button 
                    className="btn back-btn"
                    onClick={() => {
                      this.props.history.goBack();
                    }}>Terug</Button>
                  <Button
                    type="submit" 
                    className="btn continue-btn"
                    disabled={submitting}>{buttonState}</Button>
                </div>
              </Col>
            </Row>*/}
          </div>
        </PageContent>
      </React.Fragment>
    );
  }
}

GetUserDetailsForm.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object,
}

const GetUserDetails = reduxForm({
  form: 'user-details-form',
  enableReinitialize: true
})(GetUserDetailsForm);

export default GetUserDetails;

